import { Tooltip } from 'bootstrap';

export const initializeTooltips = () => {
  const elements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  [...elements].forEach((el) => {

    new Tooltip(el, {
      popperConfig: (defaultConfig) => ({
        ...defaultConfig,
        modifiers: [
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['top', 'bottom', 'left', 'right'],
            },
          },
          {
            name: 'preventOverflow',
            options: { boundary: document.body }
            ,
          },
        ],
      }),
    });

  });

};
